import React, { useEffect } from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import { bindActionCreators } from "redux";
import * as DeliveryDriversActions from "../../../store/actions/DeliveryDrivers";
import {
  DriverBasicDetailsContainer,
  FieldHolder,
} from "../../../constants/assets/DriverDetailsContainers";
import BlankState from "../../Common/BlankState";
import variables from "../../../constants/assets/variables";
import { FieldsContainer } from "../../../constants/assets/containers";

const DriverAssetDetails = ({ driverAssetDetails, getDriverAssetDetails }) => {
  const { id } = useParams();

  useEffect(() => {
    if (driverAssetDetails.length === 0) {
      getDriverAssetDetails(id);
    }
  }, []);

  return (
    <DriverAssetDetailsContainer>
      <FieldsContainer>
        <FieldHolder repeat={4} display="grid">
          <span>ID</span>
          <span>Name</span>
          <span>Quantity</span>
          <span>Size</span>
        </FieldHolder>
        {driverAssetDetails.length > 0 ? (
          driverAssetDetails.map((asset, index) => {
            return (
              <FieldHeading repeat={4} display="grid">
                <span>{asset.id}</span>
                <span>{asset.name}</span>
                <span>{asset.quantity || 0}</span>
                <span>{asset.size || "--"}</span>
              </FieldHeading>
            );
          })
        ) : (
          <BlankState message=" " />
        )}
      </FieldsContainer>
    </DriverAssetDetailsContainer>
  );
};

const DriverAssetDetailsContainer = styled(DriverBasicDetailsContainer)``;

const FieldHeading = styled(FieldHolder)`
  span {
    color: ${variables.black};
    word-break: break-all;
  }
`;

function mapStateToProps(state) {
  const { DeliveryDrivers } = state;
  return {
    driverAssetDetails: DeliveryDrivers.driverAssets,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getDriverAssetDetails: bindActionCreators(
      DeliveryDriversActions.getDriverAssetDetails,
      dispatch
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DriverAssetDetails);
